<template>
  <tr v-if="isEditing === false">
    <td class="text-center">{{ item.description.value }}</td>
    <td class="text-center">{{ item.model.value }}</td>
    <td class="text-center">{{ item.quantity.value }}</td>
    <td class="text-center">{{ item.price.value }}</td>
    <td class="text-center">{{ totalPrice }}</td>
    <td class="text-center">
      <v-btn
          :disabled="isDisabled"
          class="mr-3"
          size="x-small"
          icon="mdi-pencil"
          color="blue"
          @click="editItem"
      />
      <v-btn
          :disabled="isDisabled"
          size="x-small"
          icon="mdi-delete"
          color="red"
          @click="removeItem"
      />
    </td>
  </tr>
  <tr v-else>
      <td
          class="text-center"
      >
        <v-text-field
            v-model="item.description.value"
            :rules="item.description.rules"
            class="mt-2"
            label="Description"
        />
      </td>
      <td
          class="text-center"
      >
        <v-select
            v-model="item.model.value"
            :items="item.model.options"
            :rules="item.model.rules"
            class="mt-2"
            label="Model"
        />
      </td>
      <td
          class="text-center"
      >
        <v-text-field
            v-model="item.quantity.value"
            :rules="item.quantity.rules"
            class="mt-2"
            label="Quantity"
        />
      </td>
      <td
          class="text-center"
      >
        <v-text-field
            v-model="item.price.value"
            :rules="item.price.rules"
            :prefix="currency"
            class="mt-2"
            label="Price"
        />
      </td>
      <td
          class="text-center"
      >
        <v-text-field
            v-model="totalPrice"
            class="mt-2"
            label="Total price"
            disabled="true"
        />
      </td>
      <td
          class="text-center"
      >
        <v-btn
            class="mr-3"
            size="x-small"
            color="red"
            variant="tonal"
            icon="mdi-close"
            @click="cancelEditing"
        />
        <v-btn
            class="mr-3"
            size="x-small"
            color="success"
            variant="tonal"
            icon="mdi-check"
            @click="saveItem"
        />
      </td>
  </tr>
</template>

<script>
import moment from "moment";
import {numbers} from "@/common/numbers";

export default {
  name: "InvoiceProductTableRow",
  emits: ['removeInvoiceItem', 'saveInvoiceItem', 'saveInvoiceItem'],
  props: {
    index: Number,
    isDisabled: Boolean,
    initIsEditing: Boolean,
    initDescription: String,
    initModel: String,
    initQuantity: Number,
    initPrice: Number,
    currency: String,
    getItemValidationState: Function,
  },
  computed: {
    totalPrice() {
      return numbers.formatMoney(this.item.price.value * this.item.quantity.value, this.currency)
    }
  },
  mounted() {
    this.item.model.options = Array(moment().year() - 1949)
        .fill(moment().year())
        .map((year, index) => year - index)
    this.isEditing = this.initIsEditing
    this.item.description.value = this.initDescription
    this.item.model.value = this.initModel
    this.item.quantity.value = this.initQuantity
    this.item.price.value = this.initPrice
  },
  data() {
    return {
      isEditing: false,
      item: {
        description: {
          value: null,
          rules: [
            v => !!v || 'Description is required'
          ]
        },
        model: {
          value: null,
          options: [],
          rules: [
            v => !!v || 'Model is required'
          ]
        },
        quantity: {
          value: null,
          rules: [
            v => !!v || 'Quantity is required',
            v => /^\d{1,2}$/.test(v) || 'Quantity must be a valid number 1-99'
          ]
        },
        price: {
          value: null,
          rules: [
            v => !!v || 'Price is required',
            v => /^\d+(\.\d{2})?$/.test(v) || 'Price must be a valid number 777.77'
          ]
        },
      },
    }
  },
  methods: {
    editItem() {
      this.isEditing = true
    },
    removeItem() {
      this.$emit('removeInvoiceItem', this.index)
    },
    cancelEditing() {
      if (this.verifyNewItem()) {
        this.$emit('removeInvoiceItem', this.index)
        return
      }

      this.isEditing = false
      this.item.description.value = this.initDescription
      this.item.model.value = this.initModel
      this.item.quantity.value = this.initQuantity
      this.item.price.value = this.initPrice
    },
    verifyNewItem() {
      return this.initDescription === null
    },
    async saveItem() {
      if (!await (this.getItemValidationState())) {
        return
      }

      this.isEditing = false
      this.$emit('saveInvoiceItem', this.index, this.item)
    }
  }
}
</script>

<style scoped>

</style>